var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-menus-container"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('LeftPlace')],1),_c('el-col',{attrs:{"span":14}},[_c('RightNav')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }